import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "../common/Header";
import Footer from "../common/Footer";

const FacialCare = () => {
  let Background = "/images/facial-care.jpg";
  return (
    <div className="facial-care-container">
      <Helmet>
        <title>Facial Care Services | Eyelash Extensions & Permanent Makeup | Era Salon</title>
        <meta
          name="description"
          content="Facial care services at Era Salon in Citrus Heights, CA. We offer eyelash extensions, permanent makeup, and ear piercing. Professional beauty services to enhance your natural features. Call (916) 722-1888."
        />
        <meta
          name="keywords"
          content="eyelash extensions Citrus Heights, permanent makeup, microblading, ear piercing, facial care, beauty services, Citrus Heights eyelash extensions"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://erasalon.com/facial-care" />
        <meta property="og:title" content="Facial Care Services | Eyelash Extensions & Permanent Makeup" />
        <meta property="og:description" content="Eyelash extensions, permanent makeup, and ear piercing services at Era Salon in Citrus Heights." />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="fluid-container">
        <Header />
        <div
          className="jumbotron jumbotron-fluid"
          style={{
            backgroundImage: `url(${Background})`,
            backgroundSize: "cover",
            height: "400px",
          }}
        >
          <div className="container">
            <h1 className="display-4 text-center">Facial Services</h1>
          </div>
        </div>
        <div className="container">
          <div className="hair">
            <h2>Eyelash Extensions</h2>
            <p>
              Our professionals specialize in offering eyelash extensions to
              make sure you look your best when you enter our building and look
              beautiful when you leave!
            </p>
            <h2>Permanate Makeup</h2>
            <p>
              We have a wide array of options available to you. If you would
              like a certain kit feel free to ask us and we can accommodate you!
            </p>
            <h2>Ear piercing</h2>
            <p>
              We can piece one or both ears and can offer special designs based
              on your requirements to make sure you get the best service
              possible!
            </p>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default FacialCare;
